import { useState, useEffect } from 'react';

/**
 * Hook customizado que atrasa a atualização de um valor.
 * Útil para evitar chamadas de API excessivas em campos de busca.
 * @param value O valor a ser "debounceado".
 * @param delay O tempo de atraso em milissegundos.
 * @returns O valor após o atraso.
 */
export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};